import {reactive, ref, watch} from "vue";

export default function (getListMethod, pageLength = 25, onUpdateList = null) {
    const gridParams = reactive({
        columns: [],
        currentPage: 1,
        pageLength: pageLength,
        totalRowsCount: 0,
        pagesCount: 0,
        filters: {},
        sort: {
            field: '',
            dir: '',
        },
        selectedRows: [],
        selectedAllResults: false,
    });

    const items = ref([]);
    const listLoading = ref(false);
    const listLoaded = ref(false);

    watch(() => gridParams.pageLength, () => {
        gridParams.pagesCount = Math.ceil(gridParams.totalRowsCount / gridParams.pageLength)

        if (gridParams.currentPage > gridParams.pagesCount) {
            gridParams.currentPage = gridParams.pagesCount
        }

        updateList();
    });

    watch(() => gridParams.totalRowsCount, () => {
        gridParams.pagesCount = Math.ceil(gridParams.totalRowsCount / gridParams.pageLength);
    });

    function getCommonRequestParams(includeFilters = true) {
        let params = {
            columns: gridParams.columns.map(column => column.name),
            sort: gridParams.sort,
            currentPage: gridParams.currentPage,
            pageLength: gridParams.pageLength,
        };

        if (includeFilters) {
            params.filters = gridParams.filters;
        }

        return params;
    }

    async function resetList() {
        items.value = [];
        gridParams.currentPage = 1;
        updateList();
    }

    async function updateList() {
        listLoading.value = true;
        const {data} = await getListMethod(getCommonRequestParams());

        listLoading.value = false;
        gridParams.totalRowsCount = parseInt(data.total_count);
        gridParams.currentPage = parseInt(data.current_page);
        items.value = data.data;
        listLoaded.value = true;

        if (onUpdateList) {
            onUpdateList(data);
        }
    }

    function changePage(page) {
        gridParams.currentPage = page
        updateList();
    }

    function changeSort(sort) {
        gridParams.sort = sort
        updateList();
    }

    function changeSelectedRows(ids) {
        gridParams.selectedRows = ids
    }

    function selectAllResults(value) {
        gridParams.selectedAllResults = value
    }

    function setColumns(columns) {
        gridParams.columns = columns
    }

    function setFilters(filters) {
        gridParams.filters = filters;
        resetList();
    }

    const gridMethods = {
        updateList,
        resetList,
        changePage,
        changeSort,
        changeSelectedRows,
        selectAllResults,
        setColumns,
        setFilters,
        getCommonRequestParams,
    }

    return {
        gridParams,
        gridMethods,
        items,
        listLoaded,
        listLoading,
    }
}
